import { useAuthentication } from "@zen/identity-lib";
import { useEffect, useState } from "react";
import LoadingSpinner from "./LoadingSpinner";

const AuthSpinner: React.FunctionComponent = () => {
    const authentication = useAuthentication();
    const [isLoggedIn, setIsLoggedIn] = useState<boolean>(true);
  
    useEffect(() => {
      (async () => {
        if (authentication) {
          setIsLoggedIn(await authentication.isLoggedIn());
        } else {
          setIsLoggedIn(false);
        }
      })();
    }, [authentication])
  
    return !isLoggedIn ? <LoadingSpinner /> : null;
  }

export default AuthSpinner;